import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import styles from './index.css';

const devUrl = 'https://test0.ucms.ifeng.com/custompreview/react/ishare.ifeng.com/loc/usmidterm2026?isFull=0&immersion=true&ifengsp=1&needpage=1';
const onlineUrl = 'https://news.ifeng.com/loc/usmidterm2026?isFull=0&immersion=true&ifengsp=1&needpage=1';

class WebHeader extends React.PureComponent {

    render() {
        const { isPc = false } = this.props;
        const wxLaunchHackData = {
            callAppConfig: {
                docType: 'web',
                pid: onlineUrl,
                kind: 'inter_mgzqxj01',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7419504037123104768',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9247',
            },
            statisticsConfig: {
                behavior: 'action',
                type: 'usmidterm2026',
                ref: location.href
            },
        };

        return (
            <div className={styles.banner}>
                <div className={styles.pageBottomBox}>
                    <img className={styles.pageBottomLogo} src="https://x0.ifengimg.com/ucms/2026_44/EEF445CEF3420C909CC101B15AD7A8A458E74890_size15_w573_h111.png" alt="凤凰新闻" />
                    {/* <span className={styles.pageBottomButton}>立即打开</span> */}
                    {isPc ? null : <span className={styles.pageBottomButton}>立即打开</span>}
                </div>
                {isPc ? null : <WxLaunchHack content={wxLaunchHackData} />}
            </div>
        );
    }
}

WebHeader.propTypes = {
    isPc: PropTypes.bool,
};

export default errorBoundary(WebHeader);
